import type { JSX } from 'react';

import { withPrefetchedData } from 'src/shared/prefetch';

import { CommonPetitionDetails } from './CommonPetitionDetails';

/**
 * This is the entrypoint rendered by the staff-only `/pgamma/:slug` route.
 * TODO: Just render the main route.
 */
export const PetitionGammaStaffRoute = withPrefetchedData(
	(): JSX.Element | null => {
		return <CommonPetitionDetails />;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [CommonPetitionDetails],
	},
);
